/** Preview card frame chrome. */
export default {
  loadingPreview: "Loading preview",
  loadingPreviewProgress: "Loading preview…",
  noPreview: "No preview available",
} as const;
